import { render, staticRenderFns } from "./GalleryPrivacyModal.vue?vue&type=template&id=c9ce20c0"
import script from "./GalleryPrivacyModal.vue?vue&type=script&lang=js"
export * from "./GalleryPrivacyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports